import { render } from "./filePreviewer.vue?vue&type=template&id=ba45458a&scoped=true&ts=true"
import script from "./filePreviewer.vue?vue&type=script&lang=ts"
export * from "./filePreviewer.vue?vue&type=script&lang=ts"

import "./filePreviewer.vue?vue&type=style&index=0&id=ba45458a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba45458a"]])

export default __exports__